import { Injectable } from '@angular/core';
import { Property } from './properties.model';
import { PROPERTY } from './Properties-data';

@Injectable()
export class PropertyService {

  constructor() { }

  getProperties() {
    return PROPERTY;
  }

}



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/property.service.ts